module.exports = __webpack_public_path__ + "img/powerflowsimulation.8f93eab6.jpeg";